import React from "react";
import "./modal.css"; // You can style the modal in this CSS file
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/CloseIcon.svg"; 

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-button" onClick={onClose}>
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
